import { range } from 'lodash';
import React from 'react';

import { ShimmerLoading } from 'src/components/common/loading/ShimmerLoading';

export const FieldsListItemPlaceholder = () => (
  <div className="pt-2">
    {range(0, 15).map((i) => (
      <div
        key={`placeholder-${i}`}
        className="-ml-6 mr-1.5 flex h-10 items-center justify-between pl-6 transition-colors"
      >
        <div style={{ width: `${Math.abs(Math.sin(i)) * 25 + 40}%` }}>
          <ShimmerLoading className="h-6 w-full rounded " />
        </div>

        <ShimmerLoading className="h-6 w-[12%] rounded " />
      </div>
    ))}
  </div>
);
